import { useSelector } from "react-redux";
import { RootState } from "@/core/redux/store";
import { Pagination } from "@/shared/components/custom/data-table/pagination";
import { useDispatch } from "@/core/redux/store";

interface PaginationComponentProps {
  handlePaginationChange: (pagination: {
    pageIndex: number;
    pageSize: number;
  }) => void;
}

export default function TablePagination({
  handlePaginationChange,
}: PaginationComponentProps) {
  const dispatch = useDispatch();
  const { data, pagination } = useSelector(
    (state: RootState) => state.supplierResponsesAll
  );

  const { offset, limit, totalCount } = pagination;

  const hasPrevious = offset > 0;
  const hasNext = offset + limit < totalCount;
  const totalPages = Math.ceil(totalCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  return (
    <div className="mt-4">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        pageSize={limit}
        selectedRowCount={data.length}
        totalRowCount={totalCount}
        pageSizeOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
        onPageChange={(page) => {
          handlePaginationChange({
            pageIndex: page,
            pageSize: limit || 20,
          });
        }}
        onPageSizeChange={(size) => {
          handlePaginationChange({ pageIndex: 0, pageSize: size });
        }}
        canPreviousPage={hasPrevious}
        canNextPage={hasNext}
      />
    </div>
  );
}

